export const ID = 'acbfde1a-a4ff-11ea-bb37-0242ac130002';

export const NAME = 'Scroll To Top Button';
